
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { Details } from "@/core/services/consensu/accounts";
import SiteHeader from "./components/site-header.vue";

export default defineComponent({
  name: "SiteDetails",

  components: {
    SiteHeader,
  },

  setup() {
    const route = useRoute();
    const details = ref();

    const getData = async () => {
      details.value = await Details(route.params.id);
    };

    onMounted(() => {
      setCurrentPageTitle("Site");
      getData();
    });

    return {
      details,
    };
  },
});
